export default {
     serverAddress: "/", // protucation
     // serverAddress: "https://test.psguide.in/", // 
     // serverAddress: "http://localhost:5001/", // 
     appGooglePlayLink: 'https://play.google.com/store/apps/details?id=com.idev.g' 
}